export default {
  'counter-strike-global-offensive': {},
  custom: {},
  flick: {},
  'follow-through': {},
  fortnite: {},
  highScore: 0,
  learning: {
    moving: {},
    scaling: {},
    stationary: {},
  },
  'net-train': {},
  playCount: 0,
  ranked: {},
  speed: {},
  totalScore: 0,
  tracking: {},
  'zig-zag': {},
}

exports.defaultLastWeekCategoryStatistics = {
  highScore: 1,
  playCount: 1,
  totalScore: 1,
}

exports.defaultThisWeekCategoryStatistics = {
  highScore: 0,
  playCount: 0,
  totalScore: 0,
}



// WEBPACK FOOTER //
// ./src/app/const/weeklyStatistics.js